import { Button, Dialog, DialogContent } from '@mui/material';
import AddressFields from './AddressFields';
import TextFieldWithError from './TextFieldWithError';

const ChangeSimDialog = ({
  isDialogOpen,
  handleCloseDialog,
  handleSubmit,
  handleCopyToClipboard,
  register,
  registerOptions,
  description,
  handleDescriptionChange,
  errors,
  order_details,
  newOne,
  newTwo,
  newThree,
  setValue,
  inputChange,
  stateShrink,
  municipalityShrink,
  neighborhoodShrink,
  states,
  municipalities,
  neighborhoods,
  zipcodeShrink,
  addressShrink,
  referenceInput,
  contactPhoneShrink,
}) => (
  console.log('order_details', order_details),
  (
    <Dialog open={isDialogOpen}>
      <DialogContent style={{ width: '500px' }}>
        <form onSubmit={handleSubmit(handleCopyToClipboard)}>
          <TextFieldWithError
            register={register}
            registerOptions={registerOptions?.description}
            label='Descripción'
            variant='outlined'
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={handleDescriptionChange}
            errors={errors}
            errorKey='description'
            name='description'
            sx={{
              mb: 2,
            }}
          />
          {order_details?.sim_type_id === 2 && (
            <AddressFields
              register={register}
              registerOptions={registerOptions}
              newOne={newOne}
              newTwo={newTwo}
              newThree={newThree}
              setValue={setValue}
              inputChange={inputChange}
              errors={errors}
              states={states}
              municipalities={municipalities}
              neighborhoods={neighborhoods}
              stateShrink={stateShrink}
              municipalityShrink={municipalityShrink}
              neighborhoodShrink={neighborhoodShrink}
              zipcodeShrink={zipcodeShrink}
              addressShrink={addressShrink}
              referenceInput={referenceInput}
              contactPhoneShrink={contactPhoneShrink}
            />
          )}
          <Button variant='contained' color='primary' type='submit'>
            Cambiar
          </Button>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
        </form>
      </DialogContent>
    </Dialog>
  )
);

export default ChangeSimDialog;
